export enum AuthorizeWithPopUpStatus {
  Pristine = 'Pristine',
  Initiated = 'Initiated',
  Completed = 'Completed',
  Failed = 'Failed'
}
